import React, { useEffect, useState } from "react";
import { Row, Col, Form, Image, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Card from "../Card";
import axios from "axios";
import imgsuccess from "../../assets/images/pages/img-success.png";
import { addUser, getUserList } from "../../services/Users-services";
import { toast } from "sonner";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import profileImage from "../../assets/images/no-profile-picture.png";
import {
  addDepartment,
  getDepartmentDetails,
  updateDepartment,
} from "../../services/Users-services";
import {
  getClassesList,
  getTutorList,
  updateDivisionSection,
  createDivisionSection,
  getDivisionSectionDetails,
} from "../../services/Academic-Services";
import {
  callToast,
  prepareSiteList,
  showErrorMessages,
} from "../../../src/services/utilityFunctions.js";
import { useGlobalState } from "../../../src/services/hostelConst";
import Select from "react-select";
import { getLocalStorageData } from "../../services/axiosComponent";
import { selectStyle } from "../../services/constant";
import {closeModal} from "../../services/redux/reducers/modalSlice";
import {useDispatch} from "react-redux";
const AddDivisionSectionForm = ({ navigate, refresh }) => {
  const dispatch = useDispatch();
  const { openModal, modalState } = useGlobalState();
  const id = modalState.id;
  const [regionOptions, setRegionOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isSiteOptionsLoading, setIsSiteOptionsLoading] = useState(false);
  const [siteOptions, setSiteOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [classOptions, setClassOptions] = useState([]);
  const [isClassOptionsLoading, setIsClassOptionsLoading] = useState(false);
  const [isUserOptionsLoading, setIsUserOptionsLoading] = useState(false);
  const [isSiteSearchable, setIsSiteSearchable] = useState(true);
  const [isRegionSearchable, setIsRegionSearchable] = useState(true);
  const prepareFormData = (data = null) => {
    return {
      name: data != null ? data.NAME : "",
      discription: data != null ? data.DESCRIPTION : "",
      siteId: {
        value: data != null ? data["_SITE"] : "",
        label: data != null ? data["SITE"] : "",
      },
      regionId: {
        value: data != null ? data["_REGION"] : "",
        label: data != null ? data["REGION"] : "",
      },
      user: {
        value: data != null ? data["_DEPARTMENT HEAD_"]["_ID"] : "",
        label: data != null ? data["_DEPARTMENT HEAD_"]["NAME"] : "",
      },
      class: {
        value: data != null ? data["_CLASS"] : "",
        label: data != null ? data["CLASS"] : "",
      },
    };
  };
  const [loadingData, setLoadingData] = useState(modalState.isEditing);
  const [formData, setFormData] = useState(prepareFormData());
  const getDivisionSectionData = async (id) => {
    setLoadingData(true);
    var res = await getDivisionSectionDetails(id);
    if (res.status == "fail") {
      showErrorMessages({ data: res, navigate });
    } else {
      console.log(res, "get divisionSections details");
      setFormData(prepareFormData(res.data));
    }
    setLoadingData(false);
  };

  const handleChange = (field, value) => {
    setErrors({});
    if (field == "regionId") {
      setFormData((prev) => ({ ...prev, siteId: { value: "", label: "" } }));
      setFormData((prev) => ({
        ...prev,
        user: { value: "", label: "" },
      }));
    }
    if (field == "siteId") {
      setFormData((prev) => ({
        ...prev,
        user: { value: "", label: "" },
        class: { value: "", label: "" },
      }));
    }
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const validateFields = () => {
    let isValid = true;
    let errors = {};
    if (formData.name == "") {
      isValid = false;
      errors.name = " Name is required";
    }
    if (formData.discription == "") {
      isValid = false;
      errors.discription = "Discription is required";
    }
    if (formData.user.value == "") {
      isValid = false;
      errors.user = "Tutor is required";
    }
    if (formData.class.value == "") {
      isValid = false;
      errors.class = "Class is required";
    }
    if (formData.regionId.value == "") {
      isValid = false;
      errors.region = "Region is required";
    }
    if (formData.siteId.value == "") {
      isValid = false;
      errors.site = "Site is required";
    }
    setErrors(errors);
    return isValid;
  };

  const handleSubmit = async () => {
    if (validateFields()) {
      setLoading(true);

      var submitData = {
        id: null,
        name: formData.name,
        description: formData.discription,
        classId: formData.class.value,
        organizationId:
          getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_ID"],
        tutorId: formData.user.value,
        regionId: formData.regionId.value,
        siteId: formData.siteId.value,
      };
      var res = modalState.isEditing
        ? await updateDivisionSection(submitData)
        : await createDivisionSection(submitData);
      if (res.status == "success") {
        callToast(
          "success",
          modalState.isEditing ? "Updated" : "Created",
          modalState.isEditing
            ? "Division Section Updated successFully"
            : "Division Section added successfully"
        );

        await refresh({ columnRefresh: false, isLoading: false });
        setLoading(false);
        dispatch(closeModal());
      } else {
        console.log(res, "add Division Section resss");
        setLoading(false);
        showErrorMessages({
          data: res,
          navigate,
        });
      }
    }
  };

  const getSiteList = async (regionId, query) => {
    setIsSiteOptionsLoading(true);
    var data = await JSON.parse(localStorage.getItem("profileDetails"));
    var list = await prepareSiteList(regionId, navigate, query);

    if (
      list.length == 1 &&
      list[0].value == data._SITE &&
      data["_SITE ACCESS_"] == null
    ) {
      setIsSiteSearchable(false);
      handleChange("siteInfo", "site", {
        value: list[0].value,
        label: list[0].label,
      });
    }

    setIsSiteOptionsLoading(false);
    if (list.length == 0) {
      setErrors((prev) => ({
        ...prev,
        site: "No site available for this region",
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        site: "",
      }));
    }
    setSiteOptions(list);
  };

  const getRegionList = async () => {
    var data = await JSON.parse(localStorage.getItem("profileDetails"));
    var list = JSON.parse(localStorage.getItem("regionList"));
    if (
      list.length == 1 &&
      list[0].value == data._REGION &&
      data["_REGION_ACCESS_"] == null
    ) {
      setIsRegionSearchable(false);
      handleChange("siteInfo", "region", {
        value: list[0].value,
        label: list[0].label,
      });
    }
    setRegionOptions(list);
  };

  const getUserOptionsList = async ({ siteId, query = null } = {}) => {
    setIsUserOptionsLoading(true);
    var res = await getTutorList({
      regionId: formData.regionId.value,
      siteId: siteId,
      query: query,

      status: "Y",
    });
    if (res.status == "fail") {
      showErrorMessages({ data: res, navigate });
    } else {
      var list = [];
      res.data.entityList.map((item) => {
        list.push({
          value: item._ID,
          label: item["NAME"],
        });
      });
      if (list.length == 0)
        setErrors((prev) => ({
          ...prev,
          user: "No Tutors available for this site",
        }));
      setIsUserOptionsLoading(false);
      setUserOptions(list);
    }
  };
  const getClassedOptionList = async ({ siteId, query = null } = {}) => {
    setIsClassOptionsLoading(true);
    var res = await getClassesList({
      regionId: formData.regionId.value,
      siteId: siteId,
      query: query,
      status: "Y",
    });
    if (res.status == "fail") {
      showErrorMessages({ data: res, navigate });
    } else {
      var list = [];
      res.data.entityList.map((item) => {
        list.push({
          value: item._ID,
          label: item["NAME"],
        });
      });
      if (list.length == 0)
        setErrors((prev) => ({
          ...prev,
          class: "No class available for this site",
        }));
      setIsClassOptionsLoading(false);
      setClassOptions(list);
    }
  };

  useEffect(() => {
    getRegionList();
    if (modalState.isEditing == true) {
      getDivisionSectionData(id);
    }

    return () => {};
  }, []);

  return (
    <>
      {loadingData ? (
        <center>
          <div class="spinner-border text-primary" role="status">
     
          </div>
        </center>
      ) : (
        <section className="login-content">
          <div className="">
            {/* <div
            className="position-absolute top-10 start-20 bg-primary"
            style={{
              left: "5%",
              top: "-10%",
              width: "12%",
              height: "120%",
              backgroundColor: "blue",
            }}
          ></div> */}

            <div className="d-flex">
              <div className="w-100 ps-5 pe-5">
                <form>
                  <>
                    <div className="mb-3">
                      <div className="form-row ">
                        <div class="col">
                          <label className="form-label">
                            Division Section Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter First Name"
                            value={formData.name}
                            onChange={(e) =>
                              handleChange("name", e.target.value)
                            }
                          />
                          {errors.name && (
                            <small className="text-danger">{errors.name}</small>
                          )}
                        </div>
                        <div class="col mt-3">
                          <label className="form-label">Discription </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter last Name"
                            value={formData.discription}
                            onChange={(e) =>
                              handleChange("discription", e.target.value)
                            }
                          />
                          {errors.discription && (
                            <small className="text-danger">
                              {errors.discription}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>{" "}
                    <div className="mb-3 ">
                      <label className="form-label">Region </label>

                      <Select
                        options={regionOptions}
                        value={
                          formData.regionId.label == ""
                            ? null
                            : formData.regionId
                        }
                        onChange={(newValue) => {
                          handleChange(
                            "regionId",
                            newValue == null
                              ? { value: "", label: "" }
                              : newValue
                          );

                          if (newValue != null) {
                            getSiteList(newValue.value);
                          }
                        }}
                        onInputChange={(inputValue, { action }) => {}}
                        noOptionsMessage={() => {
                          return !isRegionSearchable
                            ? "Region Access not available"
                            : "No matches found";
                        }}
                        isSearchable={isRegionSearchable}
                        placeholder="Select Region "
                        className="basic-single"
                        classNamePrefix="select"
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                        styles={selectStyle}
                      />
                      {errors.region && (
                        <small className="text-danger">{errors.region}</small>
                      )}
                    </div>
                    <div className="mb-3 ">
                      <label className="form-label">Site</label>

                      <Select
                        styles={selectStyle}
                        options={siteOptions}
                        value={
                          formData.siteId.label == "" ? null : formData.siteId
                        }
                        components={
                          isSiteOptionsLoading
                            ? {
                                DropdownIndicator,
                              }
                            : null
                        }
                        onChange={(newValue) => {
                          handleChange(
                            "siteId",
                            newValue == null
                              ? { value: "", label: "" }
                              : newValue
                          );

                          getUserOptionsList({ siteId: newValue.value });
                          getClassedOptionList({ siteId: newValue.value });
                        }}
                        onInputChange={(inputValue, { action }) => {
                          getSiteList(formData.regionId.value, inputValue);
                        }}
                        noOptionsMessage={() => {
                          return !isSiteSearchable
                            ? "Site Access Not available"
                            : "No matches found";
                        }}
                        isSearchable={isSiteSearchable}
                        placeholder="Select Site "
                        className="basic-single"
                        classNamePrefix="select"
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                      />
                      {errors.site && (
                        <small className="text-danger">{errors.site}</small>
                      )}
                    </div>
                    <div className="mb-3 ">
                      <label className="form-label"> Class</label>

                      <Select
                        styles={selectStyle}
                        options={classOptions}
                        value={
                          formData.class.label == "" ? null : formData.class
                        }
                        components={
                          isClassOptionsLoading
                            ? {
                                DropdownIndicator,
                              }
                            : null
                        }
                        onChange={(newValue) => {
                          handleChange(
                            "class",
                            newValue == null
                              ? { value: "", label: "" }
                              : newValue
                          );
                        }}
                        onInputChange={(inputValue, { action }) => {
                          if (action === "input-change") {
                            getClassedOptionList({
                              siteId: formData.siteId.value,
                              query: inputValue,
                            });
                          }
                        }}
                        noOptionsMessage={() => {
                          return "No class available";
                        }}
                        isSearchable={true}
                        placeholder="Select Class "
                        className="basic-single"
                        classNamePrefix="select"
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                      />
                      {errors.class && (
                        <small className="text-danger">{errors.class}</small>
                      )}
                    </div>
                    <div className="mb-3 ">
                      <label className="form-label"> Tutor</label>

                      <Select
                        styles={selectStyle}
                        options={userOptions}
                        value={formData.user.label == "" ? null : formData.user}
                        components={
                          isUserOptionsLoading
                            ? {
                                DropdownIndicator,
                              }
                            : null
                        }
                        onChange={(newValue) => {
                          handleChange(
                            "user",
                            newValue == null
                              ? { value: "", label: "" }
                              : newValue
                          );
                        }}
                        onInputChange={(inputValue, { action }) => {
                          if (action === "input-change") {
                            getUserOptionsList({
                              siteId: formData.siteId.value,
                              query: inputValue,
                            });
                          }
                        }}
                        noOptionsMessage={() => {
                          return "No  Tutor  available";
                        }}
                        isSearchable={true}
                        placeholder="Select Tutor "
                        className="basic-single"
                        classNamePrefix="select"
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                      />
                      {errors.user && (
                        <small className="text-danger">{errors.user}</small>
                      )}
                    </div>
                  </>

                  <div className="d-flex justify-content-end mt-4 gap-2">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading ? (
                        <div
                          className="spinner-border text-light"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};
const DropdownIndicator = (props) => {
  return (
    <div {...props.innerProps}>
      <div
        class="spinner-border text-primary spinner-border-sm m-2"
        role="status"
      >
 
      </div>
    </div>
  );
};

export default AddDivisionSectionForm;
